import {combineReducers} from 'redux';

import {PROPERTIES_REQUEST, PROPERTIES_SUCCESS, PROPERTIES_FAILURE} from '../actions';
import {RETIRED_PROPERTIES_REQUEST, RETIRED_PROPERTIES_SUCCESS, RETIRED_PROPERTIES_FAILURE} from '../actions';
import {STORE_PROPERTY_REQUEST, STORE_PROPERTY_SUCCESS, STORE_PROPERTY_FAILURE} from '../actions';
import {UPDATE_PROPERTY_REQUEST, UPDATE_PROPERTY_SUCCESS, UPDATE_PROPERTY_FAILURE} from '../actions';
import {RETIRE_PROPERTY_REQUEST, RETIRE_PROPERTY_SUCCESS, RETIRE_PROPERTY_FAILURE} from '../actions';
import {
    PROPERTY_DOCUMENT_UPLOAD_REQUEST,
    PROPERTY_DOCUMENT_UPLOAD_SUCCESS,
    PROPERTY_DOCUMENT_UPLOAD_FAILURE,
    PROPERTY_DOCUMENT_DELETE_REQUEST,
    PROPERTY_DOCUMENT_DELETE_SUCCESS,
    PROPERTY_DOCUMENT_DELETE_FAILURE
} from '../actions';
import propertyReducer from './property';

export const PROPERTIES_INITIAL_STATE = {
    isFetching: false,
    data: [],
    links: {},
    meta: {},
    error: null
};

const updateProperty = (state, action) => {
    let {data} = state;
    const {id} = action;
    const property = data.find(b => b.id === id);
    const reduced = propertyReducer(property, action);
    data.splice(data.indexOf(property), 1, reduced);
    data = [...state.data];

    return {...state, data};
};

const retireProperty = (state, action) => {
    let {data} = state;
    const {id} = action;
    const property = data.find(b => b.id === id);
    const reduced = propertyReducer(property, action);
    if (!reduced) {
        data.splice(data.indexOf(property), 1);
    } else {
        data.splice(data.indexOf(property), 1, reduced);
    }
    data = [...state.data];
    return {...state, data};
};

const propertiesReducers = {
    [PROPERTIES_REQUEST]: (state) => {
        return {...state, isFetching: true, error: null};
    },
    [PROPERTIES_SUCCESS]: (state, {res}) => {
        return {...state, ...res, isFetching: false, error: null};
    },
    [PROPERTIES_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [RETIRED_PROPERTIES_REQUEST]: (state) => {
        return {...state, isFetching: true, error: null};
    },
    [RETIRED_PROPERTIES_SUCCESS]: (state, {res}) => {
        return {...state, ...res, isFetching: false, error: null};
    },
    [RETIRED_PROPERTIES_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [STORE_PROPERTY_REQUEST]: (state, action) => {
        const contractor = propertyReducer(undefined, action);
        const data = [...state.data.filter(b => !b.draft), contractor];

        return {...state, data};
    },
    [STORE_PROPERTY_SUCCESS]: (state, action) => {
        let {data} = state;
        const contractor = data.find(b => b.draft);
        data.splice(data.indexOf(contractor), 1);
        const reduced = propertyReducer(contractor, action);
        data = [...data, reduced];

        return {...state, data};
    },
    [STORE_PROPERTY_FAILURE]: (state, action) => {
        let {data} = state;
        const contractor = data.find(b => b.draft);
        data.splice(data.indexOf(contractor), 1);
        const reduced = propertyReducer(contractor, action);
        data = [...state.data, reduced];

        return {...state, data};
    },
    [UPDATE_PROPERTY_REQUEST]: updateProperty,
    [UPDATE_PROPERTY_SUCCESS]: updateProperty,
    [UPDATE_PROPERTY_FAILURE]: updateProperty,
    [RETIRE_PROPERTY_REQUEST]: retireProperty,
    [RETIRE_PROPERTY_SUCCESS]: retireProperty,
    [RETIRE_PROPERTY_FAILURE]: retireProperty,
    [PROPERTY_DOCUMENT_UPLOAD_REQUEST]: updateProperty,
    [PROPERTY_DOCUMENT_UPLOAD_SUCCESS]: updateProperty,
    [PROPERTY_DOCUMENT_UPLOAD_FAILURE]: updateProperty,
    [PROPERTY_DOCUMENT_DELETE_REQUEST]: updateProperty,
    [PROPERTY_DOCUMENT_DELETE_SUCCESS]: updateProperty,
    [PROPERTY_DOCUMENT_DELETE_FAILURE]: updateProperty,
};

const active = (state = PROPERTIES_INITIAL_STATE, action) => {
    let reducer = propertiesReducers[action.type] || (state => state);
    return reducer(state, action);
};

export default combineReducers({active, retired: active})


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/properties.js